export const GET_PLACES = 'GET_PLACES'
export const RESET_PLACES = 'RESET_PLACES'
export const GET_LOCATION = 'GET_LOCATION'
export const RESET_LOCATION = 'RESET_LOCATION'
export const SET_ZIPCODE = 'SET_ZIPCODE'
export const SET_SYSTEM_MESSAGE = 'SET_SYSTEM_MESSAGE'
export const SET_SYSTEM_ERROR = 'SET_SYSTEM_ERROR'
export const RESET_SYSTEM_MESSAGE = 'RESET_SYSTEM_MESSAGE'
export const CHANGE_RADIUS = 'CHANGE_RADIUS'
export const TOGGLE_TYPE = 'TOGGLE_TYPE'
export const SET_TYPES = 'SET_TYPES'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'



// WEBPACK FOOTER //
// ./src/store/types.js